import React, { useState, useEffect } from 'react';
import moment from 'moment';

const CountdownTimer = ({ dueDate, lateDate, onTimeUp}) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const targetDate = lateDate || dueDate;
    if (!targetDate) return;

    const calculateTimeLeft = () => {
      const now = moment();
      const due = moment(targetDate);
      const difference = due.diff(now);

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
        setIsExpired(false);
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        setIsExpired(true);
        if (onTimeUp) {
          onTimeUp();
        }
      }
    };

    calculateTimeLeft();

    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [dueDate, lateDate, onTimeUp]);


  const formatTimeLeft = () => {
    const parts = [];
    
    if (timeLeft.days > 0) {
      parts.push(`${timeLeft.days} day${timeLeft.days !== 1 ? 's' : ''}`);
    }
    if (timeLeft.hours > 0) {
      parts.push(`${timeLeft.hours} hour${timeLeft.hours !== 1 ? 's' : ''}`);
    }
    if (timeLeft.minutes > 0) {
      parts.push(`${timeLeft.minutes} min${timeLeft.minutes !== 1 ? 's' : ''}`);
    }
    if (timeLeft.minutes < 1 && timeLeft.seconds > 0) {
      parts.push(`${timeLeft.seconds} sec${timeLeft.seconds !== 1 ? 's' : ''}`);
    }
    
    return parts.join(', ');
  };

  return (
    <div>
      <span className="timer-text">
          {formatTimeLeft()}
      </span>
    </div>
  );
};

export default CountdownTimer;
